module.exports = __webpack_public_path__ + "static/media/mindy_pointing_admin.e241e4d7.png";